module.exports = __webpack_public_path__ + "img/Foxes-Agent-Logo-Template.jpg";